import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { useIsTeacher } from '@reducers/user/hooks';
import { useGetActiveTestSession } from '../hooks';

/**
 * Raw scaled scores are not valid for PM (category-scored) exams — the
 * Blooms-weighted scores are teacher-facing. Students who navigate to the
 * Scores/Reports pages for such an exam are sent back to the first testlet,
 * matching the behavior of the old ClayCountyRouteProtector, but driven by
 * the exam's scoring config (exam.has_pm_scoring) instead of hardcoded IDs.
 */
const PMExamStudentGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { courseId, sectionId, testSessionId } = useParams<{
    courseId: string;
    sectionId: string;
    testSessionId: string;
  }>();
  const isTeacher = useIsTeacher();
  const testSession = useGetActiveTestSession();

  const firstTestletId = testSession?.testlets?.[0]?.id;
  if (!isTeacher && testSession?.exam?.has_pm_scoring && firstTestletId) {
    return (
      <Redirect
        to={`/tests/course/${courseId}/section/${sectionId}/testsession/${testSessionId}/testlet/${firstTestletId}`}
      />
    );
  }

  return <>{children}</>;
};

export default PMExamStudentGuard;
